import { render, staticRenderFns } from "./AffirmationCategoryEditModal.vue?vue&type=template&id=0605f105"
import script from "./AffirmationCategoryEditModal.vue?vue&type=script&lang=js"
export * from "./AffirmationCategoryEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports